
/<template>
    <section class="agreementss">
        <div class="box">
            <div v-if="type == 'yinsi'" class="yinsi">
                <h4>隐私政策</h4>
                <p class="time">更新时间：2025年06月01日</p>
                <span>导言</span>
                <div class="text">
					<p style="padding-bottom:50px">
						展业牛牛（以下也称“我们”）深知个人信息对您的重要性，因此我们非常重视保护您的隐私和个人信息，我们亦将本《展业牛牛隐私政策》（以下也称“本政策”）中的内容以高度审慎的义务对待和处理。本政策与您所使用的我们的产品与/或服务息息相关，您在下载、安装、 启动、浏览、注册、登录、使用、卸载、退出我们的产品与/或服务（以下统称“使用我们的产品与/或服务”或“使用产品与/或服务”）时，我们将按照本政策的约定处理和保护您的个人信息，因此我们希望您能够仔细阅读、充分理解本政策的全文，并在需要时，按照本政策的指引，作出您认为适当的选择。本政策之中涉及的相关技术词汇，我们尽量以通俗易懂的表述向您解释，以便于您理解。<br>
						您应当在仔细阅读、充分理解本《展业牛牛隐私政策》 后选择是否同意本政策的内容以及是否同意使用我们的产品与/或服务，如果您不同意本政策的内容，将可能导致我们的产品与/或服务无法正常运行，或者无法达到我们期待的服务效果，或者无法达到您期待的个人信息保护状态，对此，您应立即停止访问/使用我们的产品与/或服务。您使用或继续使用我们提供的产品与/或服务的行为，或者您在使用或继续使用我们提供的产品与/或服务的行为之前没有以任何明示的方式向我们表达异议，都表示您充分理解和同意本《展业牛牛隐私政策》（包括更新版本）的全部内容。<br>
						展业牛牛已经以字体加粗或其他合理方式提示您重点阅读本政策中与您的权益（可能）存在重大关系的条款， 请您留意重点查阅。您应当在充分阅读、明确理解本政策前述加粗条款并同意本政策全部条款的有效性的前提下使用我们的产品与/或服务，您不会以展业牛牛未尽到合理提示义务为由而声称本政策中的条款非法或无效。如您在阅读本《展业牛牛隐私政策》过程中有任何疑惑或其他相关事宜的，我们为您提供了多种反馈渠道，具体请见本政策“如何联系我们”章节，我们会尽快为您作出解答。
						<br><strong>法律声明</strong><br>
						访问、浏览或使用展业牛牛平台以下统称“展业牛牛”表明您已阅读、理解并同意接受以下条款的约束，并遵守所有适用的法律和法规。您一旦使用展业牛牛，则须秉着诚信的原则遵守以下条款。<br>
						以下规则适用于所有展业牛牛用户或浏览者，因业务政策调整，可能随时被修改。您应经常访问本页面以了解当前的条款，因为这些条款与您密切相关。这些条款的某些条文也可能被展业牛牛中某些页面上或某些具体服务明确指定的法律通告或条款所取代，您应该了解这些内容，一旦接受本条款，即意味着您已经同时详细阅读 并接受了这些被引用或取代的条款。
						<br><strong>权利说明</strong><br>
						展业牛牛对其发行的或与合作公司共同发行的包括但不限于提供的软件及相关产品或服务的全部内容，享有知识产权，受法律保护。如果相关内容未含权利声明，并不代表展业牛牛对其不享有权利和不主张权利，您应根据法律、法规及诚信原则尊重权利人的合法权益并合法使用该内容。<br>
						未经展业牛牛书面许可，任何单位及个人不得以任何方式或理由对上述软件、产品、服务、信息、文字的任何部分进行使用、复制、修改、抄录、传播或与其它产品捆绑使用、销售，或以超级链路连接或传送、存储于信息检索系统或者其他任何商业目的的使用，但对于非商业目的的、个人使用的下载或打印（未作修改，且须保留该内容中的版权说明或其他所有权的说明）除外。<br>
						上述软件中使用和显示的商标和标识（以下统称“商标”）是展业牛牛及其关联公司在其它相关领域内注册和未注册的有关商标，受法律保护。该等软件中所载的任何内容，未经展业牛牛书面许可，任何人不得以任何方式使用展业牛牛近似名称和相关商标、标识。
						<br><strong>用户信息</strong><br>
						为展业牛牛提供相应服务之必须，您以自愿填写的方式提供注册所需的姓名、性别、电话以及其他类似的个人信息，则表示您已经了解并接受您个人信息的用途，同意展业牛牛为实现该特定目的使用您的个人信息。除此个人信息之外，其他任何您发送或提供给展业牛牛的材料、信息或文本（以下统称信息）均将被视为非保密和非专有的。展业牛牛对这些信息不承担任何义务。同时如果您提交时没有特别声明的，可视为同意展业牛牛及其授权人可以因商业或非商业的目的复制、透露、分发、合并和以其他方式利用这些信息和所有数据、图像、声音、文本及其他内容。您可阅读下面的展业牛牛隐私政策以了解更加详细的内容。同时，为能更好的给您提供网络服务，以最便利、最全面的实现您的多方位需求，展业牛牛与其合作网络服务平台提供互补性服务，为实现该服务功能的正常运行，展业牛牛与合作平台在用户同意的情况下将共享必要的用户信息。展业牛牛对于共享用户实行相同的信息安全和用户隐私政策，并监督合作网络服务平台遵守不低于展业牛牛信息安全和用户隐私政策标准的安全和隐私政策。
						<br><strong>责任限制声明</strong><br>
						不论在何种情况下，展业牛牛对由于信息网络设备维护、信息网络连接故障、智能终端、通讯或其他系统的故障、电力故障、罢工、劳动争议、暴乱、起义、骚乱、火灾、洪水、风暴、爆炸、战争、政府行为、司法行政机关的命令、其他不可抗力或第三方的不作为而造成的不能服务或延迟服务不承担责任。<br>
						无论在任何情况下（包括但不限于疏忽原因），由于使用展业牛牛上的信息或由展业牛牛平台链接的信息，或其他与展业牛牛平台链接的网站信息，对您或他人所造成任何的损失或损害（包括直接、间接、特别或后果性的损失或损害，例如收入或利润之损失，智能终端系统之损坏或数据丢失等后果），均由使用者自行承担责任（包括但不限于疏忽责任）<br>

						展业牛牛所载的信息，包括但不限于文本、图片、数据、观点、网页或链接，虽然力图准确和详尽，但展业牛牛并不就其所包含的信息和内容的准确、完整、充分和可靠性做任何承诺。展业牛牛表明不对这些信息和内容的错误或遗漏承担责任，也不对这些信息和内容作出任何明示或默示的、包括但不限于没有侵犯第三方权利、质量和没有智 能终端病毒的保证。<br>

						对于展业牛牛平台上所提及或展示的非展业牛牛产品或服务，展业牛牛仅提供基本信息。展业牛牛不是相关产品的生产者或经销者，亦不是服务的提供方。展业牛牛不就平台上提供的产品或服务做出任何声明或保证，所有展示的产品和服务应受其本公司或服务提供方所做质量承诺和条款的约束。

						<br><strong>第三方链接及服务</strong><br>

						展业牛牛可能保留有第三方网站或网址的链接及第三方服务，是否访问这些链接或接受相应服务将由用户自己作出决定，展业牛牛并不就这些链接上所提供的任何信息、数据、观点、图片、陈述或建议的准确性、完整性、充分性和可靠性提供承诺或保证。展业牛牛没有审查过任何第三方网站，对这些网站及其内容不进行控制，也不负任何责任。如果您决定访问任何与本站链接的第三方网站， 其可能带来的结果和风险全部由您自己承担。

						<br><strong>关于我们</strong><br>

						展业牛牛是指包括青岛百齐资产管理有限公司及其关联公司在内的企业运营。<br>

						关联公司是指在现在、将来控制本公司、受本公司控制或与本公司于共同控制下的公司、机构。控制指通过所有权、有投票权的股份、合同、实际运营关联或其他被依法认定的方式直接或间接地拥有影响被控制对象管理/经营的能力。<br>

						如您想更详细的了解我们的公司、平台，您可以通过本政策提供的联系方式与我们联系。<br>

						本《展业牛牛隐私政策》将帮助您了解以下内容：<br>

						一、《展业牛牛隐私政策》适用范围、相关词语涵义； <br>

						二、我们如何收集和使用您的个人信息；<br>

						三、我们如何使用Cookie和同类技术； <br>

						四、我们如何共享、转让、公开披露您的个人信息；<br>

						五、您对个人信息的管理；<br>

						六、我们如何存储和保护您的个人信息；<br>

						七、未成年人保护；<br>

						八、本《展业牛牛隐私政策》的更新；<br>

						九、如何联系我们；<br>

						十、其他。<br>

						一、本《展业牛牛隐私政策》适用范围、相关词语涵义 <br>

						（一）本《展业牛牛隐私政策》适用范围<br>

						本《展业牛牛隐私政策》为展业牛牛的所有产品与/或服务统一适用的通用内容，当您使用我们的任何产品与/或服务时，本《展业牛牛隐私政策》即适用，但如该产品与/或服务单独设置了隐私条款/隐私协议的，单独的隐私条款/隐私协议优先适用；单独的隐私条款/隐私协议未提及的内容，适用本政策。但请您注意，本《展业牛牛隐私政策》不适用于以下情况：<br>

						1、为我们的产品与/或服务提供广告服务的第三方的信息收集/处理做法；<br>

						2、我们的产品与/或服务可能会包含或链接至第三方提供的信息与/或第三方服务（包括任何第三方应用、网站、产品、服务等），这些信息与/或服务由第三方负责运营，您使用该信息与/或服务与我们无关。我们在此善意的提醒您，您在使用第三方信息与/或服务时，应留意和仔细阅读第三方向您展示的相关用户协议和隐私政策，并妥善保管和谨慎提供您的个人信息。本《展业牛牛隐私政策》仅适用于我们所收集的您的个人信息，并不适用于任何第三方对您的个人信息的收集，以及任何第三方提供的服务或第三方的信息使用规则，我们对任何第三方收集、储存和使用的您个人信息的行为在法律允许的范围内亦不承担任何责任；<br>

						3、其他非展业牛牛向您提供的产品与/或服务内容。<br>

						（一）相关词语涵义<br>

						我们的产品与/或服务：包括但不限于我们提供的软件、网站、服务（含站外服务，例如：我们的广告服务和“通过我们的服务申请或分享”的插件等）以及包含的相关产品或服务功能。<br>

						我们需要特别提醒您的是：由于我们的产品和服务较多，为您提供的产品和服务内容也有所不同，本《隐私政策》为展业牛牛统一适用的一般性隐私条款，本政策约定的用户权利和我们提供的相关信息安全保护措施均适用于我们的所有产品和服务；本政策所述之“我们的产品与/或服务”以及我们收集的您个人信息的类型和对应的使用、处理规则等可能会因您使用的具体的产品/服务（包括客户端类型、软件版本等）而有所不同，具体以您实际使用的产品/服务的实际情况为准。针对我们的某些特定产品/服务，我们还将制定特定隐私条款或隐私协议，以便更具体地向您阐明我们的隐私规则和保护措施等内容。<br>

						个人信息（出自于GB/T35273—2020《信息安全技术个人信息安全规范》）：指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。我们实际具体收集的个人信息种类以下文描述为准。<br>

						个人敏感信息（出自于GB/T35273-2020《信息安全技 术个人信息安全规范》）：指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。我们实际具体收集的个人敏感信息种类以下文描述为准。相比其他个人信息，个人敏感信息可能对您的个人权益影响更大。我们在此善意的提醒您需在谨慎考虑后再向我们提供您的个人敏感信息。<br>

						未成年人：不满十八周岁的自然人为未成年人。十六周岁以上的未成年人，以自己的劳动收入为主要生活来源的，视为完全民事行为能力人。（出自于《中华人民共 和国民法典》）<br>

						授权同意：是指您对您的个人信息进行特定处理做出明 确授权的行为，包括通过积极的行为作出授权（即明示同意），也包括通过消极的不作为而作出授权。（出自于GB/T35273-2020《信息安全技术个人信息安全规 范》）请您知悉，"授权同意"在本政策中有时亦表述为 "授权"、"同意"。<br>

						<br>

						匿名化：指通过对个人信息的技术处理，使得个人信息主体无法被识别或者被关联到，且处理后的信息不能被复原的过程。（出自于GB/T 35273-2020《信息安全技 术个人信息安全规范》）<br>

						去标识化：指通过对个人信息的技术处理，使其在不借助额外信息的情况下，无法识别或关联到个人信息主体的过程。（出自于GB/T 35273-2020《信息安全技术个 人信息安全规范》）<br>

						删除：指在实现日常业务功能所涉及的系统中去除个人 信息的行为，使其保持不可被检索、访问的状态。（出自于GB/T 35273-2020《信息安全技术个人信息安全规范》）<br>

						我们如何收集和使用您的个人信息<br>

						您在使用我们的产品与/或服务时，我们需要/可能需要 收集和使用您的一些个人信息，我们收集和使用的您的个人信息类型包括两种：第一种：我们产品与/或服务的核心业务功能所必需的信息：此类信息为产品与/或服务正常运行的必备信息，您须授权我们收集。如您拒绝提供，您将无法正常使用我们的产品与/或服务；第二种： 我们产品与/或服务的附加业务功能可能需要收集的信息：此信息为非核心业务功能所需的信息，您可以选择是否授权我们收集。如您拒绝提供，将导致附加业务功能无法实现或无法达到我们拟达到的效果，但不影响您对核心业务功能的正常使用。<br>

						我们需要特别提醒您的是：由于我们的服务较多，为您提供的内容也不同，因此核心业务功能（包括其收集的您的个人信息类型）也会因产品/服务的内容不同而有所区别，具体以产品/服务实际提供为准。除此之外，您理解并同意，我们希望提供给您的产品和服务是完善的， 所以我们会不断改进我们的产品和服务，包括技术，这意味着随着产品和服务的迭代、拓展、升级等，我们可能会经常推出新的业务功能或重新划分业务功能，并可能需要收集新的个人信息或变更个人信息使用目的或方 式。如果某一需要收集您的个人信息的功能或产品/服务未能在本《隐私政策》中予以说明的，我们会通过更新本政策、启动或浏览界面提示、弹窗、网站公告、站内信、发送邮件、短信等一种或多种方式另行向您说明该信息收集的目的、内容、使用方式和范围，并为您提供自主选择同意的方式，且在征得您同意后收集。在此过程中，如果您对相关事宜有任何疑惑的，可以通过文末提供的方式联系我们，我们会尽快为您作出解答。<br>

						您需授权我们收集和使用您的个人信息的功能/场景包括：<br>

						（一）服务内容展示/浏览<br>

						我们的产品与/或服务为您提供服务内容的展示、浏览过 程中，我们会根据您使用我们产品与/或服务的具体操作 收集您的一些信息，包括如下个人信息：<br>

						（1）<strong>设备信息：包括唯一设备识别码、登录IP地址、设备Mac地址、IM日、设备型号、设备名称、设备标识、 浏览器类型和设置、语言设置、操作系统和应用程序版本、接入网络的方式、网络质量数据、移动网络信息</strong>（包括运营商名称）、产品版本号、设备所在位置相关信息（包括您授权我们获取的地理位置信息）。我们的 APP或所使用的第三方插件（sdk）可能会收集用户信息（包括但不限于IMEI、IMSI、设备MAC地址、软件列表、设备序列号、Android ID，以上权限主要用于产品安全保障功能的实现、服务内容推送、维护/改进我们的产品与/服务之必需以及进行数据统计活跃或崩溃问题， 如超出该合理范围，我们将向您再一次申请授权，并告知超出范围的目的，您可以选择拒绝，拒绝后不影响其他功能）。为了收集上述基本的个人设备信息，我们将会申请访问您的设备信息的权限并根据您的授权获取相关信息。<br>

						（2）日志信息：当您使用本平台产品和服务时，我们的服务器会自动记录一些信息例如您对我们的产品和/ 或服务的使用情况、地址、所访问服务URL、浏览器的类型和使用的语言、下载、安装或使用移动应用和软件的信息、与通讯软件通讯的信息以及访问服务的日期、时间、时长等。<br>

						请注意，单独的设备信息、日志信息等是无法识别特定自然人身份的信息的。如果我们将这类非个人身份信息与其他信息结合用于识别特定自然人身份，或者将其与个人身份信息结合使用，则在结合使用期间，这类非个人身 份信息将被视为个人身份信息。除取得您授权或法律法 规另有规定外，我们会将该类用户信息做匿名化、去标识化处理。<br>

						（二）账号注册/登录功能<br>

						当您使用账号注册功能时，我们会收集由您主动提供给我们的一些单独或者结合识别您实名身份的信息， 包括：<strong>手机号码、验证码匹配结果，地址等信息及相关附加信息（如您所在的省份和城市、邮政编码等）并创建密码。</strong>您的密码将以加密形式进行自动存储、传输、 验证，我们不会以明文方式存储、传输、验证您的密码。您在保管、输入、使用您的密码时，应当对物理环境、电子环境审慎评估，以防密码外泄。我们收集这些信息是用以完成注册程序、为您持续稳定提供专属于注册用户的产品与/或服务，并保护您的账号安全。您应知悉，手机号码和验证码匹配结果、地址等属于您的个人敏感信息，我们收集该类信息是为了满足相关法律法规的要求，如您拒绝提供可能导致您无法使用我们的此功能，请您谨慎考虑后再提供。<br>

						我们收集这些信息是用于为您提供账号登录服务以及保障您的账号安全，防范安全风险。如您拒绝授权此类信息的，您将无法使用第三方平台的账号登录我们平台，但不影响我们为您提供的其他产品和服务的正常使用。<br>

						（三）身份认证功能<br>

						当您使用我们的产品与/或服务中的身份认证功能或服务时，为满足相关法律规定及监管要求、确保用户身份真实性、实现反欺诈等风险控制、保障系统和服务安全或提供服务之需要，我们将需要收集您的<strong>真实身份信息（可能包括姓名、身份证相关信息、面部特征信息 （静态或动态）、手机号码）（个人敏感信息）</strong>以完成实名认证，相关业务场景可能包括：注册产品时、使用信息发布等服务时、用户实名注册和交易时、购买会员时、以及其他需要进行身份认证的场景。为实现实名认证的目的，您同意我们可以自行或委托第三方向有关机构（如个人征信机构、政府机构等）提供、查询、 核对您的前述身份信息。在您实名认证成功后，如无正当事由，实名信息将无法修改，如确需修改，请您与我们联系解决。<br>

						同时，为协助您快速完成实名认证、风控核验等， 对于您曾经在我们的产品与/或服务中提供的相关实名认证信息（包括姓名、身份证相关信息、手机号码）（个人敏感信息），您同意我们可以将前述信息的全部或部 分自动预填于其他需要您实名认证的页面，您知悉并认可，我们仅协助填写，并未直接传输，只有在您点击下一步操作后才由您自行提供至对应服务系统。<br>

						另外，展业牛牛与您之间会通过消息推送、站内信、短信、邮件等方式进行互动。您知悉并同意，对于您在使用产品与/或服务的过程中提供的您的一种或多种联系方式（例如：电子邮箱、联系电话、联系地址），我们在运营中可能会向其中的一种或多种发送多类通知，用于用户消息告知、身份验证、安全验证等用途。<br>

						（四）客服、其他用户响应功能<br>

						当您与我们的客服互动时或使用其他用户响应功能时（包括：在线提交意见反馈、与在线/人工客服沟通、 提出我们的产品与/或服务的售后申请、行使您的相关个人信息控制权、其他客户投诉和需求），为了您的账号与系统安全，我们可能需要您先行提供账号信息，并与您之前的个人信息相匹配以验证您的用户身份。在您使用客服或其他用户响应功能时，我们可能还会需要收集 您的如下个人敏感信息：联系方式（您与我们联系时使用的电话号码/电子邮箱或您向我们主动提供的其他联系方式）、您与我们的沟通信息（包括文字/图片/音视频/ 通话记录形式）、与您需求相关联的其他必要信息。我们收集这些信息是为了调查事实与帮助您解决问题，如您拒绝提供可能导致您无法使用我们的客服等用户响应机制。<br>

						（五）产品安全保障功能<br>

						我们需要收集您的一些信息来保障您使用我们的产品与/或服务时的账号与系统安全，并协助提升我们的产品与/服务的安全性和可靠性，以防产生任何危害用户、 展业牛牛、社会的行为，包括您的如下个人信息：账号登录地、个人常用设备信息（例如：硬件型号、设备Mac地址、IM曰、IMSI）、登录IP地址、产品版本号、语言模式、浏览记录、网络使用习惯、服务故障信息，以及个人敏感信息：交易信息、会员实名认证信息。我们会 根据上述信息来综合判断您账号、账户及交易风险、进行身份验证、客户服务、检测及防范安全事件、诈骗监测、存档和备份用途，并依法采取必要的记录、审计、 分析、处置措施，一旦我们检测出存在或疑似存在账号安全风险时，我们会使用相关信息进行安全验证与风险排除，确保我们向您提供的产品和服务的安全性，以用来保障您的权益不受侵害。同时，当发生账号或系统安全问题时，我们会收集这些信息来优化我们的产品和服务。<br>

						您可自主选择提供个人信息的情形包括：<br>

						（一）基于设备相册权限的附加业务功能<br>

						当您使用注册账号、在线客服、意见反馈等业务功能时，我们将需要获取您的设备相册权限，并收集您提供的图片、视频内容信息（个人信息）。如您拒绝提供的仅会使您无法使用该功能，但并不影响您正常使用产品与/或服务的其他功能。当您取消该授权后，我们将不再收集该信息，也无法再为您提供上述与之对应的服务；但除非您依照法律的规定删除了您的个人信息，否则您的取消行为不会影响我们基于您之前的授权进行的个人信息的处理、存储。<br>

						（一）基于设备相机权限的附加业务功能<br>

						当您使用拍摄功能、上传图文/视频、在线客服、意见反馈等业务功能时，我们将需要获取您的设备相机权限，并收集您提供的图片、视频内容信息（个人信 息）。如您拒绝提供的仅会使您无法使用该功能，但并不影响您正常使用产品与/或服务的其他功能。相机权限是您设备上的一项设置，您可以通过设备设置页面进行管理。您开启该权限即视为您授权我们可以访问、获取、收集、使用您的该个人信息，当您取消该授权后， 我们将不再收集该信息，也无法再为您提供上述与之对应的服务；但除非您依照法律的规定删除了您的个人信 息，否则您的取消行为不会影响我们基于您之前的授权进行的个人信息的处理、存储。<br>

						（三）基于设备麦克风权限的附加业务功能<br>

						当您使用语音、视频录制、与在线客服沟通等业务功能时，我们将需要获取您的设备麦克风权限，并收集您的语音信息、语音交互信息（个人信息）。如您拒绝提供的仅会使您无法使用该功能，但并不影响您正常使用产品与/或服务的其他功能。麦克风权限是您设备上的 一项设置，您可以通过设备设置页面进行管理。同时， 您也可以随时通过产品上的相关功能设置开启/取消该权限，您开启该权限即视为您授权我们可以访问、获取、 收集、使用您的该个人信息；但当您取消该授权后，我们将不再收集该信息，也无法再为您提供上述与之对应 的服务；但除非您依照法律的规定删除了您的个人信息，否则您的取消行为不会影响我们基于您之前的授权进行的个人信息的处理、存储。<br>

						（四）基于设备日历权限的附加业务功能<br>

						当您使用预约抢券提醒、优惠提醒等业务功能时， 我们将需要获取您的设备日历权限，并收集您的日历信息（个人信息）。如您拒绝提供的仅会使您无法使用该功能，但并不影响您正常使用产品与/或服务的其他功能。日历权限是您设备上的一项设置，您可以通过设备设置页面进行管理。同时，您也可以随时通过产品上的相关功能设置开启/取消该权限，您开启该权限即视为您授权我们可以访问、获取、收集、使用您的该个人信息，但当您取消该授权后，我们将不再收集该信息，也无法再为您提供上述与之对应的服务；但除非您依照法律的规定删除了您的个人信息，否则您的取消行为不会影响我们基于您之前的授权进行的个人信息的处理、存储。<br>

						（五）基于位置权限的附加业务功能<br>

						在我们的特定服务中，我们需要申请获取您的位置 权限，并在您授权后收集您的位置信息，前述特定服务场景包括：基于我们的风控和反诈骗机制要求时、您频繁更换城市等相关服务内容等。位置权限是您设备上的 一项设置，您可以通过设备设置页面进行管理。您开启该权限即视为您授权我们可以访问、获取、收集、使用您的该个人信息；但当您取消该授权后，我们将不再收集该信息，也无法再为您提供上述与之对应的服务；但除非您依照法律的规定删除了您的个人信息，否则您的取消行为不会影响我们基于您之前的授权进行的个人信息的处理、存储。<br>

						（六）从外部第三方间接收集的您的个人信息<br>

						您知悉并同意，您向外部第三方（本公司及关联公司不在此限）提供的个人信息，或外部第三方收集的您的个人信息，我们无法获取，更不会使用非常规方式（如：恶意干预对方App数据）擅自以软件程序获得您的个人信 息。如果因业务发展的必要而需要从第三方间接收集 （如共享等）您的个人信息的，且由我们直接或联合为您提供产品或服务的，我们（或第三方）在收集前会向您明示共享的您个人信息的来源、类型、使用目的、方式和所用于的业务功能、授权同意范围（如果使用方式和范围超出您在第三方原授权范围的，我们会再次征得 您的授权同意）。<br>

						三、我们如何共享、转让、公开披露您的个人信息<br>

						（一）共享<br>

						我们非常重视保护您的个人信息。目前，未经您的授权同意，我们不会与展业牛牛以外的第三方公司、组织和个人共享您的个人信息，除非存在以下一种或多种情形：<br>

						1.您自行分享或主动提出共享要求或事先已征得您的授权同意而进行的共享：<br>

						我们会应您的合法合理的共享要求或在事先征得您授权同意后而共享您的信息，您也可主动基于展业牛牛的产品与服务的分享功能与第三人（包括不特定对象）共享您的个人信息或其他信息，但因您的共享行为而导致的信息泄露、被使用等情况，与展业牛牛无关，您需要自行承担相应的法律责任。<br>

						2.为实现我们的服务/功能所必需进行的共享：<br>

						您知悉并同意，在某些情况下，为向您提供我们的服务或实现我们的产品与/或服务的业务功能或基于合理商业习惯，我们必须共享您的个人信息，才能实现我们 的产品与/或服务的核心功能或提供您需要的服务。例如：与第三方共享联合营销活动中的中奖/获胜者等信息，以便其能及时向您发放奖品/礼品等；我们接受尽职调查或审计时等。<br>

						3.与展业牛牛公司内部的必要、合理共享；包括：<br>

						（1）您理解并同意，展业牛牛注册账号信息、设备信息、相关数据等反映您习惯和爱好的信息可能会与我们的关联公司共享。我们会努力确保关联公司采取不低于本政策所承诺的安全保障措施的程度以及遵守我们提出的其他安全保护要求来保障您的个人信息<br>

						4.与部分业务合作伙伴的必要共享：<br>

						您理解并同意，为了必要/合理的业务的顺利开展、 满足您的要求、履行我们在相关用户协议或本隐私政策中的义务和行使我们的权利或遵守法律规定等目的，我们可能需要向部分业务合作伙伴共享您的部分信息。但我们承诺我们只会共享您的必要个人信息，如果我们共享您的个人敏感信息或改变个人信息的使用及处理目的，我们会将再次征求您的授权同意。我们的业务合作伙伴包括：<br>

						（1）为我们的产品与/或服务提供功能支持的服务提供商，包括：提供支付服务的支付机构、提供一键登录服务的运营商、第三方配送公司和其他服务提供商， 我们共享信息的目的是可以实现我们产品与/或服务的功能，让您可以正常使用；<br>

						（2）我们平台的第三方商家：为实现您购买产品或服务的需求（包括享受售后服务），我们会将您的订单 信息与交易相关的信息共享给我们平台的第三方商家；<br>

						（3）提供数据服务（包括网络广告监测、数据统计、数据分析）的合作伙伴：为维护/改进我们的产品/服务、为您提供更好的内容，我们可能会与提供该服务 的指定合作伙伴共享您的相关信息（包括：浏览记录、 广告展示记录、终端型号、设备信息、您所在的城市及其他相关信息），<br>

						（4）第三方SDK类服务商：我们产品中可能会包含第三方SDK或其他类似的应用程序，如您在我们平台上使用这类由第三方提供的服务时，您同意将由其直接收集和处理您的信息（如以嵌入代码、插件等形式），例 如：<br>


						我们的产品基于DCloud uni-app(5+ App/Wap2App)开发，应用运行期间需要收集您的设备唯一识别码（IMEI/android ID/DEVICE_ID/IDFA、SIM 卡 IMSI 信息、OAID）以提供统计分析服务，并通过应用启动数据及异常错误日志分析改进性能和用户体验，为用户提供更好的服务。<br>

						个推SDK的使用：为保障授权软件的稳定运行、功能实现，使您能够享受和使用更多的服务及功能，授权软件中会嵌入授权合作伙伴的SDK；<br>

						个推SDK的目的：APP将通过个推SDK获取用户设备的BSSID、SSID以此来实现向用户推送消息的功能，获取方式是通过unipush的个推获取。unipush由每日互动股份有限公司提供推送技术服务，我们可能会将您的设备平台、设备厂商、设备品牌、设备识别码等设备信息，应用列表信息、网络信息以及位置相关信息提供给每日互动股份有限公司，用于为您提供消息推送技术服务。我们在向您推送消息时，我们可能会授权每日互动股份有限公司进行链路调节，相互促活被关闭的SDK推送进程，保障您可以及时接收到我们向您推送的消息。详细内容请访问《个推用户隐私政策》（需将《个推用户隐私政策》超链至：http://docs.getui.com/privacy）。<br>

						个推SDK的范围：<br>

						设备信息：包含设备平台、设备厂商及品牌、设备型号及系统版本、设备识别码、设备序列号，用于我们标识到独立设备实现向特定用户推送消息。<br>

						应用列表信息：我们采用合并链路技术进行技术推送，当一个设备有多个APP的推送链路同时活跃时，我们会随机合并成一条链路，以达到为您省电省流量的目的，因此需获得应用列表信息；<br>

						网络信息以及位置相关信息：为了最大程度保持网络连接的稳定性，建立长链接，我们需要了解设备的网络状态和变化，从而实现稳定连续的推送服务。我们提供应景推送功能，位置相关信息将有助于我们为您提供线下场景的精细化推送。<br>


						.其他情形：<br>

						(1)共享的是去标识化的信息，且接受该信息共享的第三方无法重新识别信息主体身份；<br>

						(2)为了保护您、我们的其他用户或员工、展业牛牛或社会公共利益、财产或安全(例如：欺诈或信用 险等)免遭损害而与第三方的共享；<br>

						(3)某些情况下，只有共享您的个人信息，才能实现我们的产品与/或服务的核心功能或提供您需要的服务，或处理您与他人的纠纷或争议；<br>

						(4)依据您与我们签署的相关协议（例如：在线协议、平台规则等）或法律文件而共享的；<br>

						(5)符合您与其他第三人之间的有关约定的；<br>

						(6)基于合理商业习惯而共享的，例如：与第三方共享联合营销活动中的中奖/获胜者等信息，以便其能及时向您发放奖品/礼品等；我们接受尽调时等；<br>

						(7)基于学术研究而使用，例如：以学术研究为目的而与学术机构共享我们使用您的相关信息集合形成的间接用户画像、去标识化或匿名化处理后的分析/统计类信息（未经您的同意，我们不会与其共享可以识别您身份的个人信息）；学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行匿名化处理的；<br>

						(8)有权机关的要求、诉讼争议需要、法律法规等规定的其他需要共享的情形。<br>

						您可以基于展业牛牛的平台与第三人(包括不特定对象)共享您的个人信息或其他信息，但因您的共享行为而导致的信息泄露、被使用等情况，与展业牛牛无关，您需要自行承担相应的法律责任。<br>

						我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享必要的个人信息。 在我们与业务合作伙伴共享信息时，我们会以多种方式保护您的个人信息，包括但不限于：(1)如具备上述合理事由且需要您授权同意的，我们会在共享前向您告知共享的信息的目的、信息接收方的类型以及可能产生的后果(如涉及共享、转让您的个人敏感信息的，我们还会向您告知涉及的个人敏感信息类型、信息接收方的身份和数据安全能力)并在取得您授权同意后再共享；（2）在合作协议层面，我们会严格要求合作伙伴的信息保护义务与责任，为此，我们的法律部门要求业务合作伙伴在合作前需与展业牛牛签署关于数据安全的保护协议， 协议严格约定了业务合作伙伴的用户信息保密义务，包括信息的保管、使用和流转等均应满足我们的管控要求，接受我们的审核、监督等，一旦有任何违反，我们将立即要求业务合作伙伴停止相关行为，并采取或要求业务合作伙伴采取相应补救措施控制或消除您的风险， 必要时业务合作伙伴将须承担相应法律责任；（3）此外，我们将对个人信息的共享、转让活动事先进行个人信息安全影响评估，并通过输出形式、流转、使用等采取有效的技术保护措施等。请您知悉，即使已经取得您的授权同意，我们也仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并尽量对共享内容中的个人信息进行匿名化处理。您理解并知悉，匿名化处理后的信息无法识别或关联到您，已不属于法律意义上的个人信息，其处理、使用、共享、转让无需征得您的授权同意。<br>

						（一）转让<br>

						转让是指将个人信息控制权向其他公司、组织或个人转移的过程。原则上我们不会将您的个人信息转让， 但以下情况除外：<br>

						您自行提出要求的；<br>

						事先已征得您的明确授权同意；<br>

						如我们进行兼并、收购、重组、分立、破产、资产转让或类似的交易，而您的个人信息有可能作为此类交易的一部分而被转移，我们会要求新持有人继续遵守和履行该《展业牛牛隐私政策》的全部内容（包括使用目的、 使用规则、安全保护措施等），否则我们将要求其重新获取您的明示授权同意；<br>

						法律法规等规定的其他情形。<br>

						如具备上述事由确需转让的，我们会在转让前向您告知转让的信息的目的、类型（如涉及您的个人敏感信息的，我们还会向您告知涉及的敏感信息的内容），并在征得您的授权同意后再转让，但法律法规另有规定的或本政策另有约定的除外。<br>

						（三）公开披露<br>

						公开披露是指向社会或不特定人群发布信息的行为。除了因需要对违规账号、欺诈行为等进行处罚公告、公布中奖/获胜者等名单时脱敏展示相关信息等必要事宜而进行的必要披露外，我们不会对您的个人信息进行公开披露，如因经法律授权或具备合理事由确需公开披露的，我们会在公开披露前向您告知公开披露的信息的目的、类型（如涉及您的个人敏感信息的，我们还会向您告知涉及的敏感信息的内容），并在征得您的明示同意后再公开披露，但法律法规另有规定的或本政策另有约定的除外。<br>

						对于公开披露的您的个人信息，我们会充分重视风险，在收到公开披露申请后第一时间且审慎审查其正当性、合理性、合法性，并在公开披露时和公开披露后采取不低于本《展业牛牛隐私政策》约定的个人信息安全保护措施和手段的程度对其进行保护。<br>

						请您知悉，即使已经取得您的授权同意，我们也仅会出于合法、正当、必要、特定、明确的目的公开披露您的个人信息，并尽量对公开披露内容中的个人信息进行匿名化处理。<br>

						（四）委托处理<br>

						为了提升信息处理效率，降低信息处理成本或提高信息处理准确性，我们可能会委托有能力的我们的关联公司或其他专业机构代表我们来处理用户信息，但我们会通过书面协议、现场审计等方式要求受托公司遵守严格的保密义务及采取有效的保密措施，禁止其将这些信息用于未经用户授权的用途。委托关系解除后，受托公司将不再保存您的个人信息。<br>

						例外情形<br>

						根据法律法规等规定，在下述情况下，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：<br>

						与我们履行法律法规规定的义务相关的； 与国家安全、国防安全直接相关的； 与公共安全、公共卫生、重大公共利益直接相关的；<br>

						与犯罪侦查、起诉、审判和判决执行等直接相关的；或根据法律法规的要求、行政机关或公检法等有权机关的要求的；<br>

						出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；<br>

						个人信息是您自行向社会公开的或者是我们从合法公开披露的渠道（如合法的新闻报道、政府信息公开等渠道）中收集到的；<br>

						根据与您签订和履行相关协议或其他书面文件所必需的；<br>

						法律法规等规定的其他情形。<br>

						（五）共享、转让、公开披露的相关责任<br>

						我们将严格按照本隐私政策的约定及相关法律法规的要求执行对个人信息的共享、转让、公开露的操作，如我们违反了法律法规或与您的约定向第三方共享、转让或公开披露个人信息的，您可以要求我们删除，我们将在收到您的请求后立即停止共享、转让、公开披露的信息，并通知第三方及时删除。<br>

						五、您对个人信息的管理<br>

						我们非常重视并保护您关于管理个人信息的权利， 并为您提供了管理个人信息的方法。您有权利访问、更正、撤销自己的信息并保护自己的隐私和安全。<br>

						1、访问权<br>

						除法律法规规定的例外情况，无论您何时使用我们的服务，我们都会力求让您顺利访问自己的个人信息。 如果您希望访问或编辑您账户中的个人资料信息（包括但不限于手机号码、电子邮箱、登录密码、手势密码等），您可以在网页端或APP端中执行此类操作，或联系展业牛牛客服进行编辑；<br>

						2、更正权<br>

						当您需要更新您的个人信息时，或发现我们处理您的个人信息有错误时，您有权做出更正或更新。您可以自行在相关网页端或APP端进行更正，或通过反馈与报错等将您的更正申请提交给我们。在您进行更新或更正前，我们可能会现要求您验证自己的身份，然后再处理您的请求。

						3、撤销权<br>

						您可以改变您授权同意的范围或撤回您的授权，但您撤回同意或授权后，我们可能将无法继续为您提供撤回同意或授权所对应的服务。同时，您知悉并理解，在您撤回同意或授权前提供的个人信息，我们将继续依照 可适用的法律法规规定及本隐私权政策进行保存或披露。<br>

						改变您授权同意的范围:<br>

						请您理解，每个业务功能往往需要开启部分权限并收集必要的个人信息才能得以实现，对于您个人信息的收集、使用以及设备权限的管理，您可以通过设备系统权限设置或联系客服要求撤回同意或删除，<br>

						当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也将不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的同意或授权而开展的个人信息处理。<br>

						4、注销权<br>

						您可以通过“展业牛牛”平台上公布的“展业牛牛”平台 客户邮箱申请注销您的账户或者注销账户按钮直接注销，我们将于24小时内将您的账户予以注销。一旦您注销账户，我们将停止为您提供服务，因此请您谨慎操作。但您知悉并理解，在您注销账户前提供的个人信息，我们将继续依照可适用的法律法规规定及本隐私权政策进行保存或披露。<br>

						5、管理问题<br>

						如果您无法通过上述方式访问、更正或撤销您的个人信息，或者您无法完成账户注销，或者您就我们收集、使用您信息存在任何疑问，您都可以通过“展业牛牛”平台客服与我们联系。为保障安全，我们可能需要您提供书面请求，或以其他方式证明您的身份。我们将在收到您的反馈并验证您身份后尽快答复您的相关请求。<br>

						我们将尽合理商业努力，满足您对于个人信息的访问、更正、撤销及账户注销的要求。但对于无端重复、 需要过多技术手段、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。<br>

						对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情况收取一定成本费用。<br>

						6、例外<br>

						按照法律法规要求，以下情况中，我们将无法响应您的请求： <br>

						（1）与国家安全、国防安全有关的；<br>

						（2）与公共安全、公共卫生、重大公共利益有关；<br>

						（3）与犯罪侦查、起诉和审判等有关的；<br>

						（4）有充分证据表明您存在主观恶意或滥用权利法权益受到严重损害的。<br>

						六、我们如何存储和保护您的个人信息<br>

						(-)个人信息的存储<br>

						1、存储地点：我们依照法律法规的规定，将您的个人信息存储于中华人民共和国境内。目前我们不存在跨境存储您的个人信息或向境外提供个人信息的场景。如需跨境存储或向境外提供个人信息的，我们会单独向您明确告知（包括出境的目的、接收方、使用方式与范围、使用内容、安全保障措施、安全风险等）并再次征得您的授权同意，并严格要求接收方按照本《隐私政策》以及法律法规相关要求来处理您的个人信息；<br>

						2、存储期限：我们在为提供我们的产品和服务之目的所必需且最短的期间内保留您的个人信息，例如：当您使用我们的注册登录及会员功能时，我们需要收集您的手机号码，且在您提供后并在您使用该功能期间，我们需要持续为您保留您的手机号码，以向您正常提供该功能、保障您的账号和系统安全。在超出上述存储期限后，我们会对您的个人信息进行删除或匿名化处理。但您行使删除权、注销账号的或法律法规另有规定的除外 （例如：《电子商务法》规定：商品和服务信息、交易信息保存时间自交易完成之日起不少于三年）。<br>

						(-)个人信息的保护措施<br>

						我们一直都极为重视保护用户的个人信息安全，为此我们采用了符合行业标准的安全技术措施及组织和管理措施等保护措施以最大程度降低您的信息被泄露、毁损、误用、非授权访问、非授权披露和更改的风险。包括：<br>

						数据安全技术措施<br>

						(1)数据安全收集方面，通过个人信息安全影响评估确认数据收集的合法性、正当性和必要性，识别并以清晰、准确的方式告知用户以征得同意，同时对用户的授权同意采集行为进行日志记录；采用敏感识别工具对收集的用户数据进行分类分级，针对不同级别的数据设置不同等级的安全策略；采用技术措施对收集或产生数数据安全技术措施。<br>

						(1)数据安全收集方面，通过个人信息安全影响评估确认数据收集的合法性、正当性和必要性，识别并以清晰、准确的方式告知用户以征得同意，同时对用户的授权同意采集行为进行日志记录；采用敏感识别工具对收集的用户数据进行分类分级，针对不同级别的数据设置不同等级的安全策略；采用技术措施对收集或产生数据的来源方进行身份识别，确保数据来源的准确性和抗抵赖性；<br>

						(2)数据安全传输方面，使用安全通道传输个人信息，并通过合适的加密算法进行安全加密、脱敏处理， 确保数据传输过程中个人信息的秘密性和完整性；<br>

						(3)数据安全存储方面，采用数据分类分级管理制度，针对数据分类分级结果采取不同的信息存储策略；个人敏感信息需加密存储，确保数据安全使用规范能够落实到位；针对存储有个人信息的数据库加强权限控制与安全审计；定期对个人信息进行备份与恢复，确保个人信息在存储使用过程中的完整性；<br>

						(4)数据安全处理方面，依照使用场景和安全需求对个人信息进行脱敏处理，例如：在前端显示个人敏感信息之前需在服务端完成脱敏处理；开发、测试环境严禁使用真实用户信息；实施严格的数据权限控制机制， 采取多重身份认证、网络/数据隔离等技术措施，确保能够对处理个人信息的行为进行有效监控，避免数据被违规访问和未授权使用；<br>

						(5)数据安全销毁方面，根据法律法规要求和业务实际需求设定个人信息存储的最小可用期限，对到期的数据通过安全删除技术进行处理，确保已销毁数据不可恢复，技术手段包括但不限于数据彻底清除方案、磁盘销毁、物理销毁等；<br>

						(6)建立完整的审计机制，对数据生命周期的全流程进行监控与审计，防止您的个人信息遭遇未经授权的访问、公开披露、使用、修改、人为或意外的损坏或丢失；<br>

						(7)其他实现数据安全保护的措施。<br>

						数据安全组织和管理措施<br>

						(1)成立专门的个人信息保护责任部门，建立相关的内控管理流程，对可能接触到您的信息的工作人员采取最小化权限原则；<br>

						(2)建立数据分类分级制度、业务数据安全使用规范、数据合作规范等管理体系，保障您的信息在收集、 传输、使用、存储、转移、销毁等环节的处置满足法律法规相关规范和安全要求；<br>

						(3)定期组织员工参加安全与隐私保护相关培训并要求完成规定的考核，加强员工对于保护个人信息重要性的认知；

						<br>(4)严格执行等级保护各项制度，通过持续迭代优化安全架构、全面提升合规框架下的安全技术支撑能力，我们的互联网业务系统、大数据平台、私有云平台、后台支撑系统等信息系统全部通过国家公安部信息安全等级测评备案，并获得了由公安部颁发的“国家信息安全等级保护三级认证”；

						<br>(5)信息安全管理和用户隐私保护能力达到国际权威认证标准的要求，并已获得了相应的认证，包括ISO/I EC 27001:2013(信息安全管理体系)和ISO/IEC 29151:20 17 (个人身份信息保护实践指南)认证，构建了完善的ISMS信息安全管理体系，并基于ISO 29151扩展了个人身份信息保护的最佳实践；

						<br>(6)其他可行的安全组织和管理措施。

						<br>合作协议条款保证

						<br>(1)在我们从第三方间接收集您的个人信息前，我们会明确以书面形式（如合作协议、承诺书）要求该第三方在已经取得您明示同意后收集以及处理(如共享 等)个人信息，在书面协议层面要求第三方对个人信息来源的合法性和合规性作出承诺，如第三方有违反行为的，我们会明确要求该第三方承担相应法律责任；

						<br>(2)在我们向业务合作伙伴共享您的个人信息前， 我们会严格要求合作伙伴的信息保护义务与责任，并要求业务合作伙伴在合作前签署关于数据安全的保护协议，一旦业务合作伙伴有任何违反协议的行为，将须承担相应法律责任；

						<br>(3)其他合作协议中明确约定的内容。

						<br>安全事件处理

						<br>(1)我们建立了合理有效、科学健全的安全应急响应体系，制定了《网络安全事件应急响应预案》、《紧急安全事件响应机制》、《重大事件应急预案》、《数据安全事件管理规范》等多项安全管理制度，明确了网络安全事件的分类分级标准、安全应急响应组织及职 责，并根据安全事件的不同类型和级别制定了适当的应急响应预案，明确规范了安全事件的报告流程和应急响 应处置流程（包括研判、分析、抑制、根除、恢复、结 果公布和经验总结）。

						<br>(2)如不幸发生个人信息安全事件的，我们将按照法律法规的要求，及时向您告知安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、电话、短信、推送通知、信件等一种或多种方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。 同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况；

						<br>(3)请您知悉并理解，互联网并非绝对安全的环境，我们强烈建议您通过安全方式、使用复杂密码、定期修改密码、不将自己的账号密码及相关个人信息披露给他人等方式，协助我们保证您的账号安全。如您发现自己的个人信息泄密，尤其是您的账户或密码发生泄露，请您立即根据本隐私政策文末中提供的联系方式联络我们，以便我们采取相应措施来保护您的信息安全。

						<br>七、未成年人保护

						<br>1、我们非常重视对未成年人个人信息的保护

						<br>如您是14-18周岁以下的未成年人，在使用我们的服务前，请务必要求您的监护人仔细阅读本隐私权政策， 并请您在征得您的监护人同意的前提下使用我们的服务或向我们提供信息。

						<br>2、补救措施

						<br>如果您未能取得您监护人的同意或您未同意您的被监护人使用我们的服务并向我们提供信息，请您或被监护人立即停止使用我们的服务并及时与我们取得联系。 在收到您的书面通知而知晓或我们自行知晓，我们在未事先获得监护人同意的情况下收集了未成年人的个人信息时，我们会立即停止相关信息收集及使用。

						<br>八、本《展业牛牛隐私政策》的更新

						<br>我们鼓励您在每次使用我们的产品或服务时都查阅我们的《隐私政策》。为了给您提供更好的服务，我们会根据产品的更新情况及法律法规的相关要求更新本 《隐私政策》的条款，该更新构成本《隐私政策》的一部分。如该更新造成您在本《隐私政策》下权利的实质减少或重大变更，我们将在本政策生效前通过在显著位置提示或向您发送推送消息或以其他方式通知您，若您继续使用我们的服务，即表示您充分阅读、理解并同意 受经修订的《隐私政策》的约束。为保障您的合法权益，我们建议您可以定期在我们平台的设置页面中查看 本政策。

						<br>上述的“重大变更”包括但不限于：

						<br>1、我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息的类型、个人信息的使用方式等；

						<br>2、我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；

						<br>3、个人信息共享、转让或公开披露的主要对象发生变化；

						<br>4、您参与个人信息处理方面的权利及其行使方式发生重大变化；

						<br>5、我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；

						<br>6、个人信息安全影响评估报告表明存在高风险时；

						<br>7、其他重要的或可能严重影响您的个人权益的情况发生时。

						<br>九、如何联系我们

						<br>（一）如果您对本隐私权政策有任何疑问、意见或建议，或您在使用我们提供的服务时，就您的个人信息的收集、使用、共享、访问、更正、撤销等相关事宜有任何意见或建议，或您在使用我们提供的服务时遇到任何问题，您都可以通过“展业牛牛”平台上公布的客服电话或者其他联络工具与我们联系。

						<br>（一）我们会在收到您的意见及建议后，并在验证您的用户身份后的15个工作日内或法律法规规定的期限内尽快向您回复，一般情况下，我们不会因此对您收取服务费。但是，在以下情形下，您理解并知悉，我们将无法响应您的请求：

						<br>与我们履行法律法规规定的义务相关的；

						<br>与国家安全、国防安全直接相关的；

						<br>与公共安全、公共卫生、重大公共利益直接相关的；

						<br>与犯罪侦查、起诉和审判等有关的

						<br>有充分证据表明您存在主观恶意或滥用权利的；

						<br>出于维护您或其他个人的生命、财产等重大权益但又难得到本人授权同意的；

						<br>响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；

						<br>涉及商业秘密的；

						<br>法律法规等规定的其他情形。
						<br>
						（三）如果您对我们的回复不满意，或我们对您个人信息的处理方式侵害了您的合法权益，且在您向我们反馈后我们仍拒绝改进的，您可以向工商、公安等监管部门进行投诉、举报。
						<br>
						十、其他
						<br>
						（一）本《隐私政策》的解释及争议解决均应适用中华人民共和国大陆地区法律。如就本政策的签订、履行等发生任何争议的，双方应尽量友好协商解决；协商不成时，任何一方均可向被告住所地享有管辖权的人民法院提起诉讼。
						<br>
						（二）本《隐私政策》的标题仅为方便及阅读而设，并不影响正文其中任何规定的含义或解释。
						<br>
						<br>
						青岛百齐资产管理有限公司
					</p>
                </div>
            </div>
            <div v-else-if="type == 'yonghu'" class="yonghu">
                <span>基础约定</span>
                <div class="text">
                    <p>
			   	1、展业牛牛（以下简称“本平台”）在此特别提醒您在注册成为用户之前，请认真阅读本《服务协议》（以下简称“本协议”，您的注册、登录、使用等行为将视为对本协议的完全接受，并同意接受本协议各项条款的约束。<br>
				2、更新与修改：本平台有权根据需要不时地修改本协议或根据本协议制定、修改各类具体规则并进行通知。您应不时地注意本协议及具体规则的变更，若您在本协议及具体规则内容公告变更之后继续使用本服务的，表示您已充分阅读、理解并接受修改后的内容，若您不同意修改后的协议内容，您应停止使用本网站的服务。<br>
				3、定义：<br>
				（1）展业牛牛：由本公司运营并适用本协议的网站手机APP客户端，旨在为用户提供周转需求信息平台技术服务。简称“本平台”。<br>
				（2）用户：同意本协议并在本平台完成注册，经本平台审核且符合国家相关规定，可在本平台提供服务或者服务代理的自然人或公司、企事业单位等机构及其工作人员。<br>
				（3）规则：展业牛牛平台制定和发布的网站管理规则和细则，在依法公告或通知到用户后生效，并成为本协议的组成部分。
				<br>（4）通知：展业牛牛平台上就相关事宜包括但不限于规则发布、协议版本更改、重要事项通知等进行的告知（或通过站内信、短信等其他方式），本平台有权选择通知的方式及公告至位置，通知一旦发出视为到达接收方，不再单独通知您。
				<br>4、特别提示：在注册和使用展业牛牛平台前，您确认您已审慎阅读、充分理解并全面接受本协议各条款内容（未成年人应在法定监护人陪同下阅读，并特别注意未成年人使用条款，详情可见平本台制定的隐私政策），特别是限制或者免除责任的条款（包括管辖条款）。限制、免责条款可能以加粗、下划线等形式提示您注意。同时，使用本服务需要您遵守公民个人信息合理使用规定，否则会面临主管部门处罚，甚至承担刑事责任！
				<br>5、本协议约定“展业牛牛”平台与您之间的权利义务。
				<br><br><strong>注册与认证</strong><br><br>
				在使用本服务之前，用户必须先行注册，取得本平台提供的展业牛牛账号（以下简称“该账号”或“展业牛牛” 账号）您在注册“展业牛牛”账号时，在符合中华人民共和国现行相关法律法规的规定的情形下，需要您授权同意使用您的相关信息（包括但不限于联系方式、借款需求、定位等）用于身份验证、客户服务、安全防范、诈骗监测等，以预防、发现、调查欺诈、危害安全、非法或违反与我们的协议、政策或规则的行为，以保护您、我们的其他用户、我们或本平台合作商及社会公众的合法权益。<br>
				当您进行登陆“展业牛牛”app账号操作时，基于我们与通信运营商的合作，我们增加了“一键登录”功能，如您选择使用该功能时，经过您的明示同意，运营商会将您的手机号码发送给我们，便于我们为您提供快捷的登录服务。手机号码属于个人敏感信息，如果拒绝提供将无法使用“一键登录”方式注册登录，但不影响您通过其他方式注册登录，也不影响其他功能的正常使用。用户同意并承诺:<br>
				1、用户是具备完全民事行为能力的自然人。无民事行为能力人、限制民事行为能力人不得注册为本平台用户，本平台一经发现，有权立即注销该账号，并保留追究其使用本服务的一切法律责任。<br>
				2、注册该账号，用户应当按照法律法规的要求，根据注册页面的提示，准确填写其身份信息及相关资料并及时更新正确、最新及完整的资料。本平台有权对用户提供的身份信息及相关资料进行核对，若有证据或有合理理由怀疑用户提供的资料错误、不实、过时或者不完整的，本平台有权暂停或终止向其提供部分或者全部服务。<br>
				3、用户不得使用他人的或虚假的身份信息等资料进行注册，由此对本平台及他人造成财产损失或其他损失的，用户应当承担相应的民事或刑事责任。<br>
				4、用户在仔细阅读完本协议以及相关协议后，点击登陆后即完成在本平台的注册行为，亦即代表用户同意并签署本协议。
				<br><br><strong>服务相关规则</strong><br><br>
				1、本平台为网络信息技术服务平台，经用户及合作平台的合法授权后，用户注册登录本平台，用户可在本平台查看并获取相关具有资质、符合中华人民共和国相关法律法规规定的机构信息，由用户自行协商相关需求事宜。<br>
				2、本平台仅为服务需求和供给双方提供交易机会与信息服务，不参与服务行为本身以及其他交易行为，不提供资金往来或托管服务。用户应审慎对待自己的交易行为，提高风险意识，亦不对经本平台撮合成功的交易行为提供任何形式的担保。<br>
				3、用户在本平台发布的服务需求信息应当遵守法律、行政法规、有关监管政策以及本平台公布的准则，本平台有权审核用户发布的信息，对于违规行为有权采取警告、删除信息、封停账户等措施。<br>
				4、您在使用我们的服务的过程中，为了更好的提供优质服务，我们将会以短信或电话形式向您推荐活动或产品内容，请您注意，以上操作我们将取得您的明确授权，您若拒绝，我们将不再提供上述服务。<br>
				<br><br><strong>用户数据的存储</strong><br><br>
				1、本平台上的服务信息，平台将采取相应的技术手段，保存时间自发生之日起三个月内，如用户自行注销本平台账户，则本平台有权立即删除用户的相关数据信息以保障用户的信息安全，需注意，该信息一经删除，不能恢复。用户可根据自己的需要在平台保存期限内自行备份本服务中的相关数据。<br>
				2、如用户停止使用本服务或本服务终止，本平台有权从服务器上永久地删除该用户数据。本服务停止、终止后，本平台没有义务向用户返还任何数据。<br>
				3、用户根据本协议以及平台的相关规则使用本服务时，本平台有权对用户服务过程进行证据固定，固定的内容仅限于用户浏览第三方机构的记录，固定的方式包括但不限于网页快照、截屏等方式。用户间发生纠纷及争议时可向本平台申请调取服务凭证。<br>

				<br><br><strong>用户帐户的管理</strong><br><br>
				1、“展业牛牛”账号的所有权归本平台所有，用户完成申请注册手续后，获得“展业牛牛”账号的使用权，该使用权仅属于初始申请注册人，禁止赠与、借用、租用、转让或售卖，否则用户将自行承担由此引发的资金风险及其他法律责任。<br>
				本平台因经营需要，有权回收用户的“展业牛牛”账号。用户注册“展业牛牛”账号后一年不登录的，本平台可以在不经通知客户时直接收回该账号，由此造成的不利后果应由用户自行承担。<br>
				2、用户有责任妥善保管注册账号信息及账号密码的安全，因用户保管不善而带来的不利后果由用户自行承担。用户需要对注册账号以及密码下的行为承担法律责任。用户怀疑本账号存在安全隐患时，需立即通知本平台采取必要措施。<br>
				3、用户应遵守本协议的各项条款，正确、适当地使用本服务，如因用户违反本协议中的任何条款，本平台在通知用户后有权依据协议中断或终止对违约用户“展业牛牛”账号提供服务。<br>
				4、如果平台发现或收到他人举报或投诉用户违反本协议约定或法律规定的，本平台有权采取必要措施对包括但不限于用户资料等信息进行审查、删除，并视情节轻重对违规账号处以包括但不限于警告、账号封禁、功能封禁等在内的处罚，并且通知用户处理结果。<br>
				<br><br><strong>购买相关规则</strong><br><br>
				为保障您的合法权益，请您在购买展业牛牛（以下简称“服务豆”或“展业币”）前阅读购买相关规则，以了解账户购买和使用规则并避免产生误解。当您点击“购买”“充值”按钮，即视为您已阅读、理解本协议，并同意按照本协议约定的规则进行购买和使用。<br>
				1、定义<br>
				购买“展业币”为一种特定的专门用来购买本平台服务的虚拟币，仅限在本平台上使用，可用于购买和查看订单支付之用。“展业币”仅限购买人本人使用，不得转让、赠与、提现，且无法在其他平台或商户使用。<br>
				2、购买方法<br>
				用户可以在此购买系统上自由选择具体的支付方式，并按相应页面提示的程序完成购买。用户仅可通过向本平台购买的方式获取“展业币”。本“展业币”一经购买即不退款，可长期使用。<br>
				3、<strong>注销账户</strong><br>
				用户充值后如果注销账户，剩余“展业币”将随注销账户一起清零和注销，且账户剩余“展业币”无法迁移到其他账户，请您注销账户时务必慎重。<br>
				4、风险提示<br>
				在使用购买方式时，用户务必仔细确认自己的帐号并仔细选择相关操作选项。若因为用户自身输入帐号错误、操作不当或不了解充购买计费方式等因素造成充错帐号、金额等情形而损害自身权益的，本平台将不会作任何补偿或赔偿。<br>
				若用户以非法的方式，或使用非本平台所指定的购买方式进行购买，本平台不保证该购买顺利或者正确完成。若因此造成用户权益受损时，本平台不会作任何补偿或赔偿，本平台同时保留随时冻结该用户帐号及使用各项所购买服务的权利。<br>
				5、订单金额<br>
				本平台上发布的订单可能会按其借需求大小、需求人资质等标准制定不同的费用（该费用以“展业币”计算并结算），用户在获得订单时应按照本平台公布的费用，向本平台支付对应的“展业币”。用户在确认查看该订单时， 本平台有权从用户的账户中扣除对应的支付币数额。<br>
				6、服务变更、中断或终止<br>
				本平台可以随时变更服务或更新本协议的条款，但应在相关的页面上及时提示修改内容。修改后的购买协议一旦在页面上公布即代替原来的服务协议。<br>
				如因系统维护或升级的需要而需暂停网络购买服务，本平台将尽可能事先进行通告。<br>
				如发生下列任何一种情形，本平台有权随时中断或终止向用户提供本协议项下的网络服务而无需通知用户：<br>
				(a)用户提供的个人资料不真实；<br>
				(b)用户违反本协议中规定的使用规则。<br>
				如因系统维护或升级的需要而需暂停或终止APP的充值服务，我们将第一时间通知您进行退款操作，具体退款规则将前提三个工作日以公告形式予以公布。<br>
				除前款所述情形外，本平台同时保留在不事先通知用户的情况下随时中断或终止部分或全部网络充值服务的权利，对于充值服务的中断或终止而造成的任何损失，本平台无需对用户或任何第三方承担任何责任。<br>
				7、免责声明和损害赔偿<br>
				本平台不保证以下事宜：<br>
				(a)本服务将符合您的要求<br>
				(b)本服务将不受干扰、及时提供、安全可靠或不会出错。<br>
				用户同意保障和维护本平台及其他用户的利益，如因用户违反有关法律、法规或本协议项下的任何条款或给任何其他第三人造成损失，用户同意承担由此造成的损害赔偿责任。<br>
				8、其他<br>
				本协议的订立、执行和解释及争议的解决均应适用中国法律。<br>
				如双方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决，协商不成，任何一方均应向本协议签订地人民法院提起诉讼。<br>
				本协议项下所有的通知均可通过重要页面公告、电子邮件或常规的信件传送等方式进行；该等通知于发送之日视为已送达收件人。
				<br><br><strong>隐私与信用</strong><br><br>
				1、用户在注册账号或使用本服务的过程中，需要按照操作提示填写或提交一些必要的信息。用户提交的信息不完整或不符合法律法规的规定的，都可能影响用户的正常使用。<br>
				2、因本平台运营需要，用户成功注册“展业牛牛”账号视为确认授权本平台提取及使用用户所填写的个人信息、需求等信息。用户授权在本平台披露用户的上述信息，以便于为用户提供供需撮合服务。<br>
				3、本平台尊重和保护用户个人信息和隐私，并按照行业标准和惯例采取必要措施确保用户的个人信息安全，防止在本服务中收集的用户个人隐私信息泄露、毁损或丢失。但本平台不保证用户的信息不通过其他非本平台原因的途径泄露，本平台不承担由此造成的责任。<br>
				4、本平台未经用户同意不向任何第三方公开、透露用户个人隐私信息。但以下特定情形除外：<br>
				(1)本平台根据法律法规规定或有权机关的指示提供用户的个人隐私信息；<br>
				(2)由于用户将其用户密码告知他人或与他人共享注册帐户与密码，由此导致的任何个人信息的泄漏，或其他非因本平台原因导致的个人隐私信息的泄露；<br>
				5、为更好的为用户提供优质服务，“展业牛牛”平台将收集和分析用户的行为数据并据此推进相关信息或改进服务流程，该等信息及数据为平台所有。<br>
				6、如需更详细了解本协议有关内容，可参考本平台制定的《隐私政策》。<br>

				<br><br><strong>用户的禁止性行为</strong><br><br>
				1、用户不得利用“展业牛牛”账号或本服务制作、上载、复制、发布、传播法律、法规和政策禁止的内容，不得干扰平台运营，不得侵犯其他用户及其他第三方权益，具体要求详见平台指定的其他规则。<br>
				2、用户须对利用“展业牛牛”账号或本服务传送信息的真实性、合法性、无害性、准确性、有效性等全权负责，与用户所传播的信息相关的任何法律责任由用户自行承担，展业牛牛对此不承担任何责任。如因此给展业牛牛或第三方造成损害的，用户应当依法予以赔偿。
				<br><br><strong>不可抗力及其他免责事由</strong><br><br>
				1、本平台在公告后对“展业牛牛”平台或相关的设备 进行检修或者维护，以保证平台的正常运行，因此类情况而造成服务在合理时间内的中断，本平台无需为此承担任何责任；<br>
				2、此外，因不可抗力、计算机病毒或黑客攻击、系统不稳定、用户所在位置、用户关机以及其他任何技术、互联网络、通信线路原因等造成的服务中断或不能满足用户要求的风险，因此导致的用户或第三方任何损失，本平台也将不承担任何责任。<br>
				3、本平台致力于为平台用户提供便捷、安全、规范的供需撮合服务，但因业务发展需要，本平台保留对本服务的全部或部分服务内容变更、暂停、终止或撤销的权利，用户需承担此风险。<br>
				4、为保障平台正常运行和交易安全，本平台有权根据风险的程度采取冻结账户、中止交易、停止提供或限制部分功能等措施，由此导致用户或第三方的损失，平台不承担任何责任。<br>
				5、因业务经营需要，发生经营主体、平台名称及其他事项变更的，本平台将以版本更新的形式进行推送，届时需要用户重新阅读并确认本协议。<br>
				<br><br><strong>纠纷的解决机制</strong><br><br>
				1、本平台为符合条件的用户提供信息平台技术服务，用户须对本服务中的内容自行加以判断，并为注册账号下的一切行为负责。如果用户发现任何人违反本协议约定或以其他不当的方式使用本服务，请立即向平台举报或投诉，平台将依本协议约定进行处理。
				2、本平台将依据法律法规、本协议约定获得处理违法违规或违约内容的权利，但该权利不构成平台的义务或承诺，本平台不能保证及时发现违法违规或违约行为或进行相应处理。<br>
				3、用户与平台之间发生纠纷与争议的，可以与平台内协商解决，也可以通过在线投诉机制向消费者协会和相关组织投诉解决，协商调解不成的，可以向本协议签订地人民法院提起诉讼。<br>
				用户产生借款纠纷及其他争议的，用户应自行协商解决，协商或者调解不成的，根据法律的规定或争议借款合同所约定的管辖地提起诉讼。本平台将提供必要的协助以帮助用户主张权益。<br><br>
				最后，本平台对本协议有最终解释权。<br><br>
				青岛百齐资产管理有限公司<br>
			</p>
                </div>
            </div>
            <div v-else-if="type == 'kehu'" class="kefut">
                <div class="text">
					<p>
		   就贵公司或贵方（乙方）委托展业牛牛（甲方）在相关网络渠道或线下渠道投放指定业务广告达成以下协议。双方确认，都已理解和认可协议全部内容，同意承担各自应承担的义务。<br>
		   <strong>一、乙方义务</strong><br>
			1、乙方保证其主体具备从事相关业务的资质或者取得具有资质机构的授权。<br>
			2、app操作者保证其是其所属机构的正式员工，并已获得从事相关业务所必要的授权。<br>
			3、乙方保证其向展业牛牛提供的资料（包括其姓名、身份证号、联系方式、公司信息等）均真实有效，并在出现任何变动时第一时间告知展业牛牛。<br>
			4、乙方保证在为广告而来的用户提供服务的过程中，不应收取除其所属机构明确公示以外的任何其他费用。<br>
			5、乙方严禁在未经相关需求用户许可的情况下，将其个人信息向第三方泄露，如违反本条款，展业牛牛将取消乙方与展业牛牛的合作资格。<br>
			6、乙方如无法向申请人之提供相关服务，乙方可以向申请人推荐其他具备资质的机构，但是必须事先获得申请人的书面许可。<br>
			7、乙方理解并认可，展业牛牛与乙方和相关需求用户之间产生的争议无关，对此亦不承担任何责任。<br>
			8、乙方所提供的服务、提供服务的过程以及所收取的费用、收取费用的方式均不违反中国的任何法律、法规，否则一律自行承担所有违法、违规后果，与展业牛牛无关。<br>
			<strong>二、乙方权利</strong><br>
			1、乙方有权变更广告标的和内容。<br>
			2、乙方有权随时停止广告推广，但是需要提前通知甲方。<br>
			<strong>三、甲方义务</strong><br>
			1、甲方保证在约定的时间内容完成乙方的广告投放需求量。<br>
			2、甲方有义务配合乙方完成广告投放形式、渠道、目标等变更优化工作。<br>
			<strong>四、甲方权利</strong><br>
			1、甲方在发现乙方资料作假、资质不足、行为服务收费违法等情况下，有权停止服务甚至终止合作，所涉及到的保证金、软件订阅费等费用不予退还。<br>
			2、甲方有权利也有义务对乙方的投放内容进行审核。<br>
			<strong>五、保密义务</strong><br>
			双方对本次合作所涉及到的文件、技术、资料、价格等信息负有保密义务。由于一方的信息泄露给对方造成损失的，泄密者应当赔偿对方不低于5倍损失的金额。<br>
			</p>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {
    props: {
        type: String,
    },
    data() {
        return {};
    },
};
</script>

<style lang="scss">
.agreementss {
    color: #2b2f3a;
    font-size: 15px;
    border-top: 1px solid #f6f6f6;
	padding-top: 59px;
    .box {
        padding: 20px 23px;
		padding-bottom: 60px;
    }
    .yinsi,
    .yonghu,
    .kefut {
        h4,
        .time,
        span {
            font-weight: bold;
        }
        h4 {
            text-align: center;
            padding-bottom: 20px;
        }
        span {
            display: block;
            padding: 7px 0;
        }
        .text {
            .text_f {
                padding-bottom: 30px;
            }
            p {
                line-height: 26px;
            }
        }
    }
    .yonghu {
        span {
            padding-top: 2px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/components/Agreements.vue